import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class InternalGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authService.isLoggedIn$.pipe(
      switchMap((isLoggedIn) => {
        if (isLoggedIn) {
          return this.authService.userInfo$.pipe(
            filter((val) => !!val),
            take(1),
            map((info) => {
              console.log(info);
              if (info.permissions.includes('internal')) {
                return true;
              }
              return this.router.parseUrl(`/auth/login`);
            }),
          );
        }
        return of(this.router.parseUrl('/auth/login'));
      }),
    );
  }
}
